export default [
  {
    key: 'Cliente directo',
    label: 'Cliente direto'
  },
  {
    key: 'Distribuidor autorizado',
    label: 'Distribuidor autorizado'
  },
  {
    key: 'Marketing',
    label: 'Marketing'
  },
  {
    key: 'Ventas',
    label: 'Vendas'
  },
  {
    key: 'Proyectos',
    label: 'Projetos'
  }
]
